import { render } from "./Vnud-Notifications.vue?vue&type=template&id=19268afd"
import script from "./Vnud-Notifications.vue?vue&type=script&lang=js"
export * from "./Vnud-Notifications.vue?vue&type=script&lang=js"

import "./Vnud-Notifications.vue?vue&type=style&index=0&id=19268afd&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__